core.directive('esfRegon9Validator', [
        function() {
            var definition = {
                require: 'ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    ctrl.$validators.regonValidator = function(modelValue, viewValue) {

                        if(scope.identifierType == Enum.IDENTIFIER_TYPE.OTHER || (scope.identifierType == Enum.IDENTIFIER_TYPE.OTHER && modelValue.length < 11)) {
                            return true;
                        }
                        if(!modelValue) {
                            return false;
                        }
                        var regon = modelValue;
                        var reg = /^[0-9]{9}$/;
                        if(reg.test(regon) == false) {
                            return false;
                        } else {
                            var dig = (""+regon).split("");
                            var kontrola = (8*parseInt(dig[0]) + 9*parseInt(dig[1]) + 2*parseInt(dig[2]) + 3*parseInt(dig[3]) + 4*parseInt(dig[4]) + 5*parseInt(dig[5]) + 6*parseInt(dig[6]) + 7*parseInt(dig[7]))%11;
                            if(kontrola == 10) kontrola = 0;
                            return (parseInt(dig[8])==kontrola);
                        }
                    }
                }
            };

            return definition;
        }]
);